module.exports = __webpack_public_path__ + "img/news-information.9c6842f9.jpg";